import React, { ReactNode } from 'react';
import IconArrowRight from '../Icons/IconArrowRight';
import Text from '../Text';
import Wrapper from '../Wrapper';

import './NotificationCard.less';

export type NotificationCardProps = {
  icon?: ReactNode;
  title?: ReactNode;
  description?: string;
  date?: string;
  backgroundColor?: string;
  arrowIconColor?: string;
  onClick?: () => void;
};

const NotificationCard: React.FC<NotificationCardProps> = ({
  icon,
  date,
  onClick = () => {},
  title,
  description,
  backgroundColor,
  arrowIconColor,
}) => {
  return (
    <div
      style={{ backgroundColor: backgroundColor }}
      className="t-notification-card"
      onClick={() => onClick()}
    >
      <div className="t-icon-container">
        <div className="t-icon-wrapper">{icon}</div>
      </div>
      <div className="t-text-block-container">
        <div>
          <Text semiBold level={2} rows={1}>
            {title}
          </Text>
          <Text textColor="dark-50" level={3} rows={1}>
            {description}
          </Text>
          <Text textColor="dark-20" level={4} rows={1}>
            {date}
          </Text>
        </div>
        <Wrapper ml={2}>
          <IconArrowRight fill={arrowIconColor} />
        </Wrapper>
      </div>
    </div>
  );
};

export default NotificationCard;
